import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './PageHeader.css';

const PageHeader = ({ title, icon, subtitle }) => {
  return (
    <div className="page-header">
      <div className="page-header-content">
        <div className="header-icon">
          <FontAwesomeIcon icon={icon} />
        </div>
        <div className="header-text">
          <h1>{title}</h1>
          {subtitle && <p className="subtitle">{subtitle}</p>}
        </div>
      </div>
      <div className="page-header-pattern"></div>
    </div>
  );
};

export default PageHeader; 